import { inject, Injectable } from "@angular/core";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { ModuleService } from "src/app/services/feature-access-control/module.service";
import { MODULES } from "src/app/core/modules";
import { PlatformService } from "src/app/services/platform.service";
import { isE2ETests } from "src/app/support/e2e-tests";
import { SoftwareProduct } from "src/app/support/product";
import { PRODUCT_TOKEN } from "src/app/core/product.token";
import { SessionService } from "src/app/services/session.service";

@Injectable()
export class EnableIdleSessionGuard {
  readonly #bootstrapService = inject(BootstrapService);
  readonly #sessionService = inject(SessionService);
  readonly #moduleService = inject(ModuleService);
  readonly #platformService = inject(PlatformService);

  readonly #product = inject(PRODUCT_TOKEN);

  async canActivate(): Promise<boolean> {
    switch (true) {
      case isE2ETests():
      case this.#platformService.isMobile():
      case this.#product === SoftwareProduct.PLATFORM:
      case this.#product === SoftwareProduct.DROP_PAGE:
      case !this.#moduleService.canBeActivatedSync(MODULES.SESSION_AUTO_LOCK): {
        return true;
      }
      default: {
        if (this.#bootstrapService.getCurrentUser()?.dynamicLockEnabled) {
          if (await this.#sessionService.isIdlePermimssionGranted()) {
            await this.#sessionService.activateIdleDetection();
          } else {
            if (await this.#sessionService.canAskForPermission()) {
              await this.#sessionService.notifyUserAbountIdlePermission();

              this.#sessionService.requestIdlePermission().then((result) => {
                if (result) {
                  window.location.reload();
                }
              });
            } else {
              console.warn(
                "[EnableIdleSessionGuard] idle permission not granted"
              );
            }
          }
        }

        return true;
      }
    }
  }
}
